export default __webpack_public_path__ + "static/media/logo-linkedin-icon-2048.4eb86c11.png";